import React, { useEffect, useState, useCallback } from "react";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import CircularProgress from "@mui/material/CircularProgress";

export default function OutageNoteDialog({ type, openStatus, handleDialogOpen, handleCreateNote, note, outageNote }) {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [text, setText] = useState("");

    const handleClose = useCallback(() => {
        setLoading(true);
        setText("");
        setOpen(false);
        handleDialogOpen(false, null, "");
    }, [handleDialogOpen]);

    const fetchNote = useCallback(async () => {
        if (outageNote) {
            setText(outageNote);
        }

        setLoading(false);
    }, [outageNote]);

    useEffect(() => {
        if (openStatus) {
            handleOpen();

            if (type === "history") {
                let noteText = note ?? "";

                setText(noteText);
                setLoading(false);
            } else {
                fetchNote();
            }
        } else {
            handleClose();
        }
    }, [openStatus, note, type, handleClose, fetchNote]);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleTextChange = (e) => {
        setText(e.target.value);
    };

    const handleCreate = (_, text) => {
        handleCreateNote(text);
        handleClose();
    };

    return (
        <div>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" fullWidth maxWidth="sm">
                <DialogContent>
                    {loading ? (
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <CircularProgress />
                        </div>
                    ) : (
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Outage Note"
                            multiline
                            rows={8}
                            fullWidth
                            variant="outlined"
                            value={text}
                            onChange={handleTextChange}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={(e) => handleCreate(e, text)} color="primary">
                        {type === "history" ? "Update" : "Save"}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
